import { brandEmail, brandText } from "./brand.ts";

// Language State Management
export const state = {
  lang: "en",
};

// Get language from URL or localStorage
export function getInitialLang(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(location.search);
  const langParam = urlParams.get("lang");
  if (langParam && ["en", "lv", "it"].includes(langParam)) {
    return langParam;
  }

  // Fall back to localStorage
  const savedLang = localStorage.getItem("dammi_lang");
  if (savedLang && ["en", "lv", "it"].includes(savedLang)) {
    return savedLang;
  }

  // Default to English
  return "en";
}

// Update email button with language-specific template
export function updateEmailButton(lang: string): void {
  const emailButton = document.getElementById(
    "email-button",
  ) as HTMLAnchorElement;
  if (!emailButton) return;

  const emailTemplates = {
    en: {
      subject: "Process Optimization Inquiry",
      body:
        "Hello DAMMI.LV team,\n\nI am interested in learning more about your process optimization services.\n\nBest regards",
    },
    lv: {
      subject: "Procesu Optimizācijas Pieprasījums",
      body:
        "Labdien DAMMI.LV komanda,\n\nEs vēlētos uzzināt vairāk par jūsu procesu optimizācijas pakalpojumiem.\n\nAr cieņu",
    },
    it: {
      subject: "Richiesta di Ottimizzazione dei Processi",
      body:
        "Buongiorno team DAMMI.LV,\n\nSono interessato a saperne di più sui vostri servizi di ottimizzazione dei processi.\n\nCordiali saluti",
    },
  };

  const template = emailTemplates[lang as keyof typeof emailTemplates] ||
    emailTemplates.en;
  const subject = encodeURIComponent(brandText(template.subject));
  const body = encodeURIComponent(brandText(template.body));

  emailButton.href = `mailto:${brandEmail("info")}?subject=${subject}&body=${body}`;
}

// Translation Function
export function switchLang(lang: string): void {
  state.lang = lang;

  // Update all text elements with data attributes
  document.querySelectorAll(`[data-${lang}]`).forEach((el) => {
    const element = el as HTMLElement;
    // Add fade effect
    element.classList.add("opacity-0", "fade-text");
    setTimeout(() => {
      // Check if it's an input placeholder or text content
      const text = brandText(element.getAttribute(`data-${lang}`) || "");
      if (
        element.tagName === "INPUT" || element.tagName === "TEXTAREA"
      ) {
        (element as HTMLInputElement).placeholder = text;
      } else {
        element.innerHTML = text;
      }
      element.classList.remove("opacity-0");
    }, 200);
  });

  // Update Buttons style
  document.querySelectorAll(".lang-btn").forEach((btn) => {
    const button = btn as HTMLElement;
    const btnLang = button.getAttribute("data-lang");
    if (btnLang === lang) {
      button.classList.remove("text-slate-500", "hover:text-slate-800");
      button.classList.add(
        "bg-white",
        "shadow-sm",
        "text-slate-800",
        "font-bold",
      );
    } else {
      button.classList.add("text-slate-500", "hover:text-slate-800");
      button.classList.remove(
        "bg-white",
        "shadow-sm",
        "text-slate-800",
        "font-bold",
      );
    }
  });

  // Update email button with language-specific template
  updateEmailButton(lang);

  // Update URL with language parameter
  const url = new URL(location.href);
  url.searchParams.set("lang", lang);
  history.pushState({ lang: lang }, "", url.toString());

  // Persist preference in localStorage
  localStorage.setItem("dammi_lang", lang);
}

